import React from 'react';
import InputBase from '@mui/material/InputBase';
import NativeSelect from '@mui/material/NativeSelect';
import { alpha } from '@mui/material/styles';
import type { Option } from './labelForm';

interface UnitSelectProps<T extends string> {
  value: T;
  options: ReadonlyArray<Option<T>>;
  onChange: (value: T) => void;
  'aria-label': string;
}

/** Unit picker docked to the right edge of a measurement input (e.g. "lb", "in"). */
function UnitSelect<T extends string>({ value, options, onChange, 'aria-label': ariaLabel }: UnitSelectProps<T>) {
  return (
    <NativeSelect
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
      input={<InputBase />}
      inputProps={{ 'aria-label': ariaLabel }}
      sx={(theme) => ({
        alignSelf: 'stretch',
        flexShrink: 0,
        borderLeft: 1,
        borderColor: 'divider',
        bgcolor: alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.04 : 0.08),
        '& .MuiNativeSelect-select': {
          height: '100%',
          boxSizing: 'border-box',
          py: 0,
          pl: 1.25,
          pr: '26px !important',
          fontSize: 13,
          fontWeight: 600,
          color: 'text.secondary',
        },
        '& .MuiNativeSelect-icon': { right: 4, color: 'text.secondary' },
      })}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </NativeSelect>
  );
}

export default UnitSelect;
